import SoundManager from "../../../../../shared/lib/html5-software-library/src/ranj/audio/SoundManager";
import Button from "../../../../../shared/lib/html5-software-library/src/ranj/components/buttons/Button";
import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import AbstractMediator from "../../../../../shared/src/ranj/app/ui/AbstractMediator";

export default class InfoPanelButtonMediator extends AbstractMediator {
    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {SoundManager} soundManager
     * @param {AppModel} appModel
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);
    }

    initialize() {
        super.initialize();

        this._button = new Button(this._target);
    }

    destroy() {
        super.initialize();
    }

    get button() {
        return this._button;
    }

    show(instant = false, showNudge = false) {
        this._ensureInitialYSet();

        this._target.visible = true;
        const targetY = this._initialY;
        if (instant) {
            this._target.y = targetY;
        } else {
            createjs.Tween.get(this._target)
                .to({ y: targetY }, 500, createjs.Ease.backOut)
                .call(() => {
                    if (showNudge) {
                        this._nudgeOnce(2);
                    }
                });
        }
    }

    hide(instant = false) {
        this._ensureInitialYSet();

        const targetY = this._initialY - 300;
        if (instant) {
            this._target.y = targetY;
            this._target.visible = false;
        } else {
            createjs.Tween.get(this._target)
                .to({ y: targetY }, 500, createjs.Ease.sineOut)
                .call(() => this._target.visible = false);
        }
    }

    blink(target, count = 2) {
        target.alpha = 1;
        const props = { loop: count * 2 - 1, bounce: true };
        createjs.Tween.get(target, props).to({ alpha: 0 }, 500);
    }

    _ensureInitialYSet() {
        if (this._initialY === undefined) {
            this._initialY = this._target.y;
        }
    }

    _stopNudges() {
        this.killDelayedCall(this._nudgeTimeout);
        this._nudgeTimeout = null;
        if (!!this._nudgeTarget) {
            createjs.Tween.removeTweens(this._nudgeTarget);
            this._nudgeTarget.alpha = 1;
            this._nudgeTarget = null;
        }
    }


    _scheduleNudge(delay = 6000) {
        if (!!this._nudgeTimeout) {
            this.killDelayedCall(this._nudgeTimeout);
        }
        this._nudgeTimeout = this.callDelayed(this._nudge.bind(this), delay / AppModel.speedFactor);
    }

    _nudge() {
        this.killDelayedCall(this._nudgeTimeout);
        this._nudgeTarget = this._target;
        this.blink(this._target, 3);
        this._scheduleNudge(8500);
    }

    _nudgeOnce(blinkCount) {
        this.killDelayedCall(this._nudgeTimeout);
        this._nudgeTarget = this._target;
        this.blink(this._nudgeTarget, blinkCount);
    }
}